import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { Button, FormControl, Input, Box, TextField, Typography } from '@mui/material'

import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import { selectErrorMessagesByKeyName } from '../../../../reducers/reference_errormessages';



const InputAnswerText = (props) => {
    const [response, setResponse] = useState(props.question.Responses[0].Response)

    const { settings } = useSelector((state) => state.viewinstance)

    const { invalidAnswer, setInvalidAnswer } = useState(!(response.length || response != "-1"))

    const dispatch = useDispatch()
    const error_valrange = useSelector((state)=> selectErrorMessagesByKeyName(state,'VAL RANGE PART1'))
    const error_valprecision = useSelector((state)=> selectErrorMessagesByKeyName(state,'VAL PRECISION PART1'))
    const error_valprecision2 = useSelector((state)=> selectErrorMessagesByKeyName(state,'VAL PRECISION PART2'))
    const error_invalidchars = useSelector((state)=> selectErrorMessagesByKeyName(state,'VAL INVALID CHARS'))
    const error_mustbenumeric = useSelector((state)=> selectErrorMessagesByKeyName(state,'VAL NUMERIC INPUT'))
    const error_wholenumber = useSelector((state)=> selectErrorMessagesByKeyName(state,'VAL INTEGER'))
    const error_text = useSelector((state)=> selectErrorMessagesByKeyName(state,'VAL TEXT'))
    const error_age = useSelector((state)=> selectErrorMessagesByKeyName(state,'VAL DATE'))
  
    const validationMessages = {
        HeightOutOfRange: "Height out of Range",
        InvalidAgeTooOld: error_age && error_age.length>0 ? error_age[0].MessageTypeContent:"This assessment was designed for those <number> years of age or younger",
        InvalidAgeTooYoung: error_age && error_age.length>0 ? error_age[0].MessageTypeContent:"This assessment was designed for those <number> years of age or older",
        InvalidDate: "Invalid Date",
        InvalidPrecision: (error_valprecision && error_valprecision.length>0 ? error_valprecision[0].MessageTypeContent: "Too many decimal places. Use less than ") + ' <number> '+ (error_valprecision2 && error_valprecision2.length>0 ? error_valprecision2[0].MessageTypeContent: ""),
        NotANumber: (error_mustbenumeric && error_mustbenumeric.length>0 ? error_mustbenumeric[0].MessageTypeContent: "Must be a number"),
        OutOfRange: (error_valrange && error_valrange.length>0 ? error_valrange[0].MessageTypeContent: "Must be between") + " <low> - <high>",
        WholeNumbers: (error_wholenumber && error_wholenumber.length>0 ? error_wholenumber[0].MessageTypeContent: "Only whole numbers") 
    }
    const [inputState, setInputState] = useState({
        invalidAnswer: false, //on ComponenetDidMount, put logic in to update htis based on response
        answer: props.question.Responses[0].Response ? props.question.Responses[0].Response : '',
        valMin: props.question.ValueLimitationMin,
        valMax: props.question.ValueLimitationMax,
        valPrecision: props.question.ValueLimitationPrecision,
        errorMessage: "",
        inputError: false,
        saving: false
    })

    const handleEnter = (event) => {
        if (event.key == "Enter" && !inputState.invalidAnswer) {
            props.saveAnswer(inputState.answer, props.QuestionId)
        }
    }

    const onChange = (ev, v) => {
        let value = ev.target.value
        let message = inputState.errorMessage
        let validation = validationMessages
        //validation goes here
        //...
        //...

        if (value) {

 if (inputState.valMin.length && inputState.valMax.length && (Number(value.length) < Number(inputState.valMin) || Number(value.length) > Number(inputState.valMax))) {
                
                message = validation.OutOfRange.replace('<low>', inputState.valMin).replace('<high>', inputState.valMax)
                //message = "" + dispatch(selectErrorMessagesByKeyName('VAL RANGE PART1')).
            }

            
             else {
                message = ''
            }
    

        }
        else {
            message = ''
        }

        setInputState({
            ...inputState,
            errorMessage: message,
            inputError: message.length ? true : false,
            answer: value,
            invalidAnswer: message.length ? true : false
        })

        
    }

    const onBlur = () => {
        //console.log(ev)
        setTimeout(() => {
            
            if (!inputState.invalidAnswer && !inputState.helpOpen) {

                setInputState({ ...inputState, saving: true })
                props.saveAnswer(inputState.answer ? inputState.answer : '-1', props.QuestionId)
            }
        }, 100)
    }

    const handleClick = (ev) => {
        if (!inputState.invalidAnswer && !inputState.saving) {
            props.saveAnswer(inputState.answer, props.QuestionId)
        }
    }

    const button = <Button
        disabled={inputState.invalidAnswer}
        variant="contained"
        color="primary"
        onClick={handleClick}
        aria-label="Save and Next"
    >
        <NavigateNextIcon /></Button>

    return (
        <Box m={1}>
            <TextField
                shrink
                borderRadius={0}
                value={inputState.answer}
                variant="outlined"
                error={inputState.invalidAnswer}
                helperText={inputState.errorMessage}
                label={props.question.QuestionPrompt.length ? props.question.QuestionPrompt : "input"}
                onChange={onChange}
                onKeyPress={handleEnter}
                onBlur={onBlur}
                InputProps={{ endAdornment: button }}
                aria-invalid={inputState.invalidAnswer}
                required={props.question && props.question.QuestionRequiredFlag && props.question.QuestionRequiredFlag ==='1'}
            />
        </Box>
    )

}

export default InputAnswerText